import { QualificationJSON } from '@scale/shared/types/qualification/types';
import { useMutation, UseMutationResult } from 'react-query';
import apiFetch, { defaultApiFetchErrorHandler, HTTPError } from 'react-scale/lib/api-fetch';

export const useCreateQualification = (
  onSuccess?: (data: QualificationJSON) => void,
): UseMutationResult<QualificationJSON, unknown, Omit<QualificationJSON, '_id' | 'id'>> => {
  return useMutation(
    ['createQualification'],
    async (qualification: Omit<QualificationJSON, '_id' | 'id'>) => {
      const result = await apiFetch<QualificationJSON>(null, 'corp-api/scalers/qualifications', {
        method: 'POST',
        body: {
          newQualification: qualification,
        },
        passError: true,
      });

      return result;
    },
    {
      onSuccess,
      onError: (err: HTTPError) => defaultApiFetchErrorHandler(err, { handleHttp: true }),
    },
  );
};
